import styled from 'styled-components';
import { Modal } from 'reactstrap';
import { colors, breakpoints } from 'components/Theme';
import { asRem } from 'utils';

export default styled(Modal)`
  .modal-dialog {
    margin: ${asRem(16)};

    @media (min-width: ${breakpoints.sm}) {
      max-width: ${asRem(660)} !important;
      margin: ${asRem(16)} auto;
    }

    @media (min-width: ${breakpoints.md}) {
      max-width: ${asRem(900)} !important;
    }
  }

  .modal-content {
    background-color: ${colors.blue.c800};
    color: ${colors.white.c500};
    border-radius: ${asRem(16)};
    border: none;
    overflow: hidden;
    position: relative;
  }

  img.bush {
    position: absolute;
    bottom: 0;
    height: ${asRem(110)};
    width: auto;
    z-index: 1;

    @media (min-width: ${breakpoints.md}) {
      height: ${asRem(140)};
    }
  }

  img.bush-left {
    left: 0;
  }

  img.bush-right {
    right: 0;
  }

  .modal-body {
    padding: ${asRem(40)} ${asRem(24)} 0;
    position: static;
  }

  .close-btn {
    position: absolute;
    top: ${asRem(16)};
    right: ${asRem(16)};
    background: none;
    border: none;
    color: ${colors.white.c500};
    font-size: ${asRem(30)};
    line-height: 1;
    cursor: pointer;
    padding: ${asRem(4)};
    z-index: 2;

    &:hover {
      opacity: 0.7;
    }

    &:focus-visible {
      opacity: 0.7;
      outline: 2px solid ${colors.white.c500};
      outline-offset: ${asRem(2)};
    }
  }

  .content {
    text-align: center;
  }

  .list-wrapper {
    padding: 0 ${asRem(8)};
    margin-bottom: ${asRem(24)};

    @media (min-width: ${breakpoints.md}) {
      padding: 0 ${asRem(48)};
    }

    .closing-list {
      @media (min-width: ${breakpoints.md}) {
        text-align: center;
      }
    }
  }

  .ft {
    margin-bottom: ${asRem(40)};
  }

  .illustration-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: ${asRem(130)};
    margin-top: ${asRem(16)};
    position: relative;
    z-index: 2;

    @media (min-width: ${breakpoints.md}) {
      height: ${asRem(160)};
    }

    img.balloonie {
      height: ${asRem(120)};
      width: auto;

      @media (min-width: ${breakpoints.md}) {
        height: ${asRem(150)};
      }
    }
  }
`;
